import React, { useState } from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import AuthImage from "../AuthImage";

/**
 * Non-resizable post photo. Caps at maxSize (default 500px width).
 * Click opens a viewport-fitting lightbox unless lightbox=false (then onActivate).
 */
function PostPhoto({
  src,
  description = "",
  maxSize = 500,
  alt,
  lightbox = true,
  onActivate,
}) {
  const [open, setOpen] = useState(false);
  const label = description || alt || "Foto";

  const handleClick = () => {
    if (!lightbox) {
      onActivate?.();
      return;
    }
    setOpen(true);
  };

  return (
    <>
      <Box
        component="figure"
        sx={{
          m: 0,
          maxWidth: maxSize,
          width: "100%",
          cursor: "pointer",
        }}
        onClick={handleClick}
      >
        <AuthImage
          src={src}
          alt={label}
          style={{
            display: "block",
            maxWidth: "100%",
            width: "auto",
            height: "auto",
            borderRadius: 8,
          }}
        />
        {description ? (
          <Typography
            component="figcaption"
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", mt: 0.75 }}
          >
            {description}
          </Typography>
        ) : null}
      </Box>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullScreen
        PaperProps={{
          sx: {
            bgcolor: "rgba(0,0,0,0.92)",
            m: 0,
          },
        }}
      >
        <IconButton
          aria-label="Luk"
          onClick={() => setOpen(false)}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 1,
            color: "#fff",
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            height: "100%",
            p: { xs: 1, sm: 3 },
            boxSizing: "border-box",
          }}
          onClick={() => setOpen(false)}
        >
          <Box
            sx={{
              position: "relative",
              maxWidth: "100%",
              maxHeight: "100%",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <AuthImage
              src={src}
              alt={label}
              style={{
                display: "block",
                maxWidth: "100vw",
                maxHeight: "100vh",
                width: "auto",
                height: "auto",
                objectFit: "contain",
              }}
            />
            {description ? (
              <Box
                sx={{
                  position: "absolute",
                  left: 0,
                  right: 0,
                  bottom: 0,
                  px: 2,
                  py: 1.5,
                  background: "linear-gradient(transparent, rgba(0,0,0,0.75))",
                }}
              >
                <Typography variant="body2" sx={{ color: "#fff" }}>
                  {description}
                </Typography>
              </Box>
            ) : null}
          </Box>
        </Box>
      </Dialog>
    </>
  );
}

export default PostPhoto;
